export default "__VITE_ASSET__biWt2u_R__"